export enum LocationDetail {
  COMPARE,
  UPDATES,
  COORDINATE_VALIDATION,
  EDIT
}